<script>
  import ToolTip from "@/components/atoms/ToolTip.vue";

  export default {
    name: "IconWithTooltip",
    components: { ToolTip },
    props: {
      styles: {
        type: Object,
        default: () => ({ width: "20px", height: "20px" }),
      },
      img: {
        type: String,
        default: "",
      },
      alt: {
        type: String,
        default: "",
      },
      text: {
        type: String,
        default: "",
      },
      showToolTip: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<template>
  <div class="iconWithTooltip" @click="$emit('onClick')">
    <ToolTip v-if="showToolTip" variant="down" :text="text" />
    <img class="iconWithTooltip__img" :src="img" :alt="alt" :style="styles" />
  </div>
</template>

<style lang="scss">
  .iconWithTooltip {
    width: fit-content;
    &__img {
      border-radius: 4px;
    }
  }
</style>
